import _ from 'lodash';

export function nextUnsignedSignature(signatures = []) {
  const orderedSignatures = _.orderBy(signatures, 'ordinal');

  return orderedSignatures.find((signature) => !signature.signed_at) ?? null;
}

export function isAgreementSignatory(agreement, memberId) {
  if (!agreement?.signatures || !memberId) return false;

  return agreement.signatures.some((signature) => signature.signatory_id === memberId);
}

export function isNextAgreementSigner(agreement, memberId) {
  if (!agreement || !memberId) return false;
  if (!['Sent', 'Partial'].includes(agreement.status)) return false;

  const nextSignature = nextUnsignedSignature(agreement.signatures);
  return nextSignature?.signatory_id === memberId;
}

export function canEditDraftAgreement(agreement, role) {
  return role === 'organization' && agreement?.status === 'Drafted';
}

export function agreementViewerMessage(agreement, memberId, options = {}) {
  if (!agreement) return null;
  if (isNextAgreementSigner(agreement, memberId)) return null;
  if (canEditDraftAgreement(agreement, options.role)) return null;

  if (agreement.status === 'Drafted') {
    return 'This agreement has not been sent yet.';
  }

  if (['Sent', 'Partial'].includes(agreement.status)) {
    if (isAgreementSignatory(agreement, memberId)) {
      return 'Awaiting another signature before it is your turn to sign.';
    }

    return 'You are not a signatory on this agreement.';
  }

  if (['Signed', 'Accepted'].includes(agreement.status)) {
    return 'This agreement has been completed.';
  }

  return 'You cannot sign this agreement right now.';
}
